import Link from 'next/link';
import Image from 'next/image';

interface FooterLink {
  label: string;
  href: string;
}

const footerLinks: FooterLink[] = [
  { label: 'Home', href: '/homepage' },
  { label: 'About Us', href: '/about' },
  { label: 'Products', href: '/portfolio' },
  { label: 'Resources', href: '/services' },
  { label: 'Contact Us', href: '/contact' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary border-t-2 border-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 lg:py-16">
        {/* Main Footer Content - Optimized spacing */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12 lg:mb-14">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link href="/homepage" className="inline-block group mb-5">
              <Image
                src="/assets/images/tmpel38iurj-1763955681228.jpg"
                alt="CR Elevator Logo"
                width={180}
                height={60}
                className="transition-transform duration-fast group-hover:scale-105"
                priority
              />
            </Link>
            <p className="font-body text-sm lg:text-base text-text-secondary leading-relaxed max-w-md">
              Your trusted partner for premium vertical transportation solutions. Delivering quality elevator products and exceptional service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-headline font-bold text-base lg:text-lg text-primary mb-5">
              Quick Links
            </h3>
            <ul className="space-y-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="font-body text-sm text-text-secondary transition-opacity duration-fast hover:opacity-70"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-headline font-bold text-base lg:text-lg text-primary mb-5">
              Get in Touch
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:sales@crelevator.com"
                  className="font-body text-sm text-text-secondary transition-opacity duration-fast hover:opacity-70"
                >
                  sales@crelevator.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+18882094030"
                  className="font-body text-sm text-text-secondary transition-opacity duration-fast hover:opacity-70"
                >
                  +1 (888) 209-4030
                </a>
              </li>
              <li>
                <a
                  href="tel:+17708525050"
                  className="font-body text-sm text-text-secondary transition-opacity duration-fast hover:opacity-70"
                >
                  +1 (770) 852-5050
                </a>
              </li>
              <li className="pt-2">
                <p className="font-body text-xs font-semibold text-primary mb-1">
                  Corporate Headquarters
                </p>
                <p className="font-body text-sm text-text-secondary">
                  820 Shallowford Rd NE
                  <br />
                  Kennesaw, GA 30144
                  <br />
                  United States
                </p>
              </li>
              <li className="pt-2">
                <p className="font-body text-xs font-semibold text-primary mb-1">
                  Distribution Center
                </p>
                <p className="font-body text-sm text-text-secondary">
                  4191 JVL Industrial Park Dr
                  <br />
                  Marietta, GA 30066
                  <br />
                  United States
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar - Improved spacing */}
        <div className="pt-6 lg:pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-body text-xs text-muted-foreground">
              &copy; {currentYear} CR Elevator. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link
                href="/privacy"
                className="font-body text-xs text-muted-foreground transition-opacity duration-fast hover:opacity-70"
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms"
                className="font-body text-xs text-muted-foreground transition-opacity duration-fast hover:opacity-70"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;